import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import * as XLSX from 'xlsx';
import {
    recuperaDocumentosXTipo,
    recuperaExperienciaXEmpleado,
    recuperaFamliaresXEmpleado,
    recuperaTelefonosXEmpleado
} from '../../services/empleado/empleadoDocumentoService';
import { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';

const ListaReportesXls = ({ funcSalir, lstEmpleados }) => {
    const lstIdsEmpleados = lstEmpleados.map((item) => item.empleadoId);

    const toastGenera = useRef();
    const dataLista = [
        {
            id: 1,
            nombre: 'Exportar Licencias Conducir',
            codigoReporte: 232,
            titulo: 'Licencia'
        },
        {
            id: 2,
            nombre: 'Exportar Libretas Militar',
            codigoReporte: 231,
            titulo: 'Libreta'
        },
        {
            id: 3,
            nombre: 'Exportar Educacion',
            codigoReporte: 230,
            titulo: 'Educacion'
        },
        {
            id: 4,
            nombre: 'Exportar Historial',
            codigoReporte: 229,
            titulo: 'Historial'
        },
        
        {
            id: 5,
            nombre: 'Exportar Otros Documentos',
            codigoReporte: 228,
            titulo: 'Otro Documento'
        },
        {
            id: 6,
            nombre: 'Exportar Telefonos',
            codigoReporte: 0,
            titulo: 'Telefonos'
        },
        {
            id: 7,
            nombre: 'Exportar Familiares',
            codigoReporte: 0,
            titulo: 'Familiares'
        },
        {
            id: 8,
            nombre: 'Exportar Experiencia Laboral',
            codigoReporte: 0,
            titulo: 'Experiencia Laboral'
        },

        {
            id: 9,
            nombre: 'Exportar Dotación de Activos (EPPs)',
            codigoReporte: 235,
            titulo: 'Dotacion'
        },
    ];

    const [generando, setGenerando] = useState(false);
    const [datosSel, setDatosSel] = useState([]);

    const transformDatosDoc = (datosOrigen, prefijo) => {
        // nueva funcion
        const agrupa = datosOrigen.reduce((acc, item) => {
            const llave = item.nroDocEntidad;
            if (!acc[llave]) {
                acc[llave] = {
                    tipoDocEntidad: item.tipoDocEntidad,
                    nroDocEntidad: item.nroDocEntidad,
                    nombreEntidad: item.nombreEntidad,
                    documentos: []
                };
            }
            const unDocumento = {
                categoria: item.categoriaLit,
                referencia: item.referencia,
                inicio: item.fechaInicio,
                fin: item.fechaFin
            }
            if (item.fechaEmision && item.fechaEmision.length !== 0) {
                unDocumento['emision'] = item.fechaEmision
            }
            acc[llave].documentos.push(unDocumento);
            return acc;
        }, {});

        const listaEmpleados = Object.values(agrupa);

        const maxDocumentos = Math.max(...listaEmpleados.map((e) => e.documentos.length), 0);

        return listaEmpleados.map((empleado) => {
            const fila = {
                'Tipo Documento': empleado.tipoDocEntidad,
                Documento: empleado.nroDocEntidad,
                'Nombre Empleado': empleado.nombreEntidad
            };

            for (let index = 0; index < maxDocumentos; index++) {
                const num = index + 1;
                const t = empleado.documentos[index];

                if (index > 0) {
                    fila[`sep_${num}_${prefijo}`] = '|';
                }

                // si existe t
                fila[`${prefijo}_${num}_Categoria`] = t ? t.categoria : '';
                fila[`${prefijo}_${num}_Referencia`] = t ? t.referencia : '';
                fila[`${prefijo}_${num}_Inicio`] = t ? t.inicio : '';
                fila[`${prefijo}_${num}_Fin`] = t ? t.fin : '';
                fila[`${prefijo}_${num}_Emision`] = t && t.emision ? t.emision : '';
                
            }
            return fila;
        });
    };

    const transformDatosTelefono = (datosOrigen) => {
        const agrupa = datosOrigen.reduce((acc, item) => {
            const llave = item.nroDocEntidad;
            if (!acc[llave]) {
                acc[llave] = {
                    tipoDocEntidad: item.tipoDocEntidad,
                    nroDocEntidad: item.nroDocEntidad,
                    nombreEntidad: item.nombreEntidad,
                    documentos: []
                };
            }
            acc[llave].documentos.push({
                tipoTelefonoLit: item.tipoTelefonoLit,
                numero: item.numero,
                referencia: item.referencia,
                esPrincipal: item.esPrincipal
            });
            return acc;
        }, {});

        const listaEmpleados = Object.values(agrupa);

        const maxDocumentos = Math.max(...listaEmpleados.map((e) => e.documentos.length), 0);

        return listaEmpleados.map((empleado) => {
            const fila = {
                'Tipo Documento': empleado.tipoDocEntidad,
                Documento: empleado.nroDocEntidad,
                'Nombre Empleado': empleado.nombreEntidad
            };

            for (let index = 0; index < maxDocumentos; index++) {
                const num = index + 1;
                const t = empleado.documentos[index];

                if (index > 0) {
                    fila[`sep_${num}_Tel`] = '|';
                }
                fila[`Tel_${num}_TipoTelefono`] = t ? t.tipoTelefonoLit : '';
                fila[`Tel_${num}_Numero`] = t ? t.numero : '';
                fila[`Tel_${num}_Referencia`] = t ? t.referencia : '';
                fila[`Tel_${num}_EsPrincipal`] = t ? t.esPrincipal : '';
            }
            return fila;
        });
    };

    const transformDatosFamilia = (datosOrigen) => {
        const agrupa = datosOrigen.reduce((acc, item) => {
            const llave = item.nroDocEntidad;
            if (!acc[llave]) {
                acc[llave] = {
                    tipoDocEntidad: item.tipoDocEntidad,
                    nroDocEntidad: item.nroDocEntidad,
                    nombreEntidad: item.nombreEntidad,
                    documentos: []
                };
            }
            acc[llave].documentos.push({
                tipoIdentificador: item.tipoIdentificadorLit,
                identificador: item.identificador,
                nombreFamiliar: item.nombreFamiliar,
                tipoFamiliar: item.tipoFamiliarLit,
                parentesco: item.parentescoLit,
                fechaNacimiento: item.fechaNacimiento,
                esCarga: item.esCargaFamiliar,
                aplicaUtilidad: item.aplicaUtilidad
            });
            return acc;
        }, {});

        const listaEmpleados = Object.values(agrupa);
        const maxDocumentos = Math.max(...listaEmpleados.map((e) => e.documentos.length), 0);

        return listaEmpleados.map((empleado) => {
            const fila = {
                'Tipo Documento': empleado.tipoDocEntidad,
                Documento: empleado.nroDocEntidad,
                'Nombre Empleado': empleado.nombreEntidad
            };
            for (let index = 0; index < maxDocumentos; index++) {
                const num = index + 1;
                const t = empleado.documentos[index];

                if (index > 0) {
                    fila[`sep_${num}_Fam`] = '|';
                }

                // si existe t
                fila[`Familia_${num}_TipoIdenficador`] = t ? t.tipoIdentificador : '';
                fila[`Familia_${num}_Idenficador`] = t ? t.identificador : '';
                fila[`Familia_${num}_NombreFamilia`] = t ? t.nombreFamiliar : '';
                fila[`Familia_${num}_TipoFamilia`] = t ? t.tipoFamiliar : '';
                fila[`Familia_${num}_Parentesco`] = t ? t.parentesco : '';
                fila[`Familia_${num}_FecNacimiento`] = t ? t.fechaNacimiento : '';
                fila[`Familia_${num}_EsCargaFamiliar`] = t ? t.esCarga : '';
                fila[`Familia_${num}_AplicaUtilidad`] = t ? t.aplicaUtilidad : '';
            }
            return fila;
        });
    };

    const transformDatosExperiencia = (datosOrigen) => {
        const agrupa = datosOrigen.reduce((acc, item) => {
            const llave = item.nroDocEntidad;
            if (!acc[llave]) {
                acc[llave] = {
                    tipoDocEntidad: item.tipoDocEntidad,
                    nroDocEntidad: item.nroDocEntidad,
                    nombreEntidad: item.nombreEntidad,
                    documentos: []
                };
            }

            acc[llave].documentos.push({
                empresa: item.empresa,
                proyecto: item.proyecto,
                fechaIngreso: item.fechaIngreso,
                fechaSalida: item.fechaSalida,
                motivoSalida: item.motivoSalida
            });
            return acc;
        }, {});

        const listaEmpleados = Object.values(agrupa);
        const maxDocumentos = Math.max(...listaEmpleados.map((e) => e.documentos.length), 0);

        return listaEmpleados.map((empleado) => {
            const fila = {
                'Tipo Documento': empleado.tipoDocEntidad,
                Documento: empleado.nroDocEntidad,
                'Nombre Empleado': empleado.nombreEntidad
            };

            for (let index = 0; index < maxDocumentos; index++) {
                const num = index + 1;
                const t = empleado.documentos[index];

                if (index > 0) {
                    fila[`sep_${num}_Exp`] = '|';
                }

                fila[`Experiencia_${num}_Empresa`] = t ? t.empresa : '';
                fila[`Experiencia_${num}_Proyecto`] = t ? t.proyecto : '';
                fila[`Experiencia_${num}_FechaIngreso`] = t ? t.fechaIngreso : '';
                fila[`Experiencia_${num}_FechaSalida`] = t ? t.fechaSalida : '';
                fila[`Experiencia_${num}_MotivoSalida`] = t ? t.motivoSalida : '';
            }
            return fila;
        });
    };

    const mergeTransformados = (listaPrincipal, listaSecundaria) => {
        const mapaSecundario = listaSecundaria.reduce((acc, item) => {
            acc[item.Documento] = item;
            return acc;
        }, {});

        return listaPrincipal.map((empleadoPrincipal) => {
            const documento = empleadoPrincipal.Documento;
            const datosExtra = mapaSecundario[documento] || {};

            const camposExtraFiltrados = {};

            Object.keys(datosExtra).forEach((key) => {
                if (!['Tipo Documento', 'Documento', 'Nombre Empleado'].includes(key)) {
                    camposExtraFiltrados[key] = datosExtra[key];
                }
            });

            return {
                ...empleadoPrincipal,
                sepAdi: '||',
                ...camposExtraFiltrados,
                sepAdi2: '||',
            };
        });
    };

    const procesosPorId = {
        1: recuperaDocumentosXTipo,
        2: recuperaDocumentosXTipo,
        3: recuperaDocumentosXTipo,
        4: recuperaDocumentosXTipo,
        5: recuperaDocumentosXTipo,
        6: recuperaTelefonosXEmpleado,
        7: recuperaFamliaresXEmpleado,
        8: recuperaExperienciaXEmpleado
    };

    const transformPorId = {
        1: transformDatosDoc,
        2: transformDatosDoc,
        3: transformDatosDoc,
        4: transformDatosDoc,
        5: transformDatosDoc,
        6: transformDatosTelefono,
        7: transformDatosFamilia,
        8: transformDatosExperiencia
    };

    const handleGuardar = async () => {
        if (datosSel.length === 0) {
            toastGenera.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Debe Seleccionar algun Dato'
            });
            return;
        }
        setGenerando(true);
        try {
            let listaFinalTotal = [];
            for (const row of datosSel) {
                const procesoAsignado = procesosPorId[row.id];
                const transformasignado = transformPorId[row.id];
                if (procesoAsignado) {
                    try {
                        const objPost = {
                            tipoRegistroConfId: row.codigoReporte,
                            lstEntidadIds: lstIdsEmpleados
                        };
                        const datos = await procesoAsignado(objPost);
                        //console.log('GENERADOS PARA ', row.id, ' .. DATOS: ', datos);
                        const trastornados = transformasignado(datos, row.titulo);
                        //console.log('GENERADOS PARA ', row.id, ' .. TRANSFORMADOS: ', trastornados);
                        if (listaFinalTotal.length === 0) {
                            listaFinalTotal = trastornados;
                        } else {
                            listaFinalTotal = mergeTransformados(listaFinalTotal, trastornados);
                        }
                        // 3. Generar el reporte
                        // generaReporteDoc(datos, row);
                    } catch (error) {
                        console.error(`Error procesando ID ${row.id}:`, error.message);
                    }
                } else {
                    console.error('No hay proceso configurado para ');
                }
            }
            //console.log('XXXXX - RESULTADO FINAL ES... ', listaFinalTotal);
            //pasarlo al excel
            const mapa = listaFinalTotal.map((fila) => {
                const nuevaFila = {};
                Object.keys(fila).forEach((key, index) => {
                    if (key.startsWith('sep')) {
                        const espacios = ' '.repeat(index + 1);
                        nuevaFila[espacios] = fila[key];
                    } else {
                        nuevaFila[key] = fila[key];
                    }
                });
                return nuevaFila;
            });
            const worksheet = XLSX.utils.json_to_sheet(mapa);
            const objectMaxLength = [];
            mapa.forEach((fila) => {
                Object.keys(fila).forEach((key, i) => {
                    if (key.trim() === '') {
                        objectMaxLength[i] = 1;
                        return;
                    }
                    const valor = fila[key] ? fila[key].toString() : '';
                    objectMaxLength[i] = Math.max(
                        objectMaxLength[i] || 0,
                        valor.length,
                        key.length
                    );
                });
            });
            worksheet['!cols'] = objectMaxLength.map((w) => ({ width: w + 2 }));

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, `Reporte_Datos`);

            XLSX.writeFile(workbook, 'Reporte_general.xlsx');
        } finally {
            setGenerando(false);
            //funcSalir();
        }
    };

    return (
        <>
            <Toast ref={toastGenera} />
            <DataTable
                value={dataLista}
                size="small"
                showGridlines
                loading={generando}
                selection={datosSel}
                onSelectionChange={(evt) => setDatosSel(evt.value)}
                dataKey="id"
            >
                <Column header="Datos del empleado" field="nombre" />
                <Column
                    selectionMode="multiple"
                    headerStyle={{ width: '3rem' }}
                    exportable={false}
                ></Column>
            </DataTable>
            <Button label="Generar" onClick={handleGuardar} icon="pi pi-file-excel" />
        </>
    );
};

export default ListaReportesXls;
